import React, { useState, useEffect } from 'react';
import './HeaderSection.scss';
import Logo from "../../assets/icons/logo.png";
import { Link } from "react-router-dom";

const HeaderSection = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 860) {
        setIsMenuOpen(false);
      }
    };

    // Set initial state based on current window width
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className='container'>
      <nav className="header">
        <button className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </button>
        <ul className={`navbar-nav ${isMenuOpen ? 'active' : ''}`}>
          <li className={`nav-item logo-item ${isMenuOpen ? '' : 'hidden'} `}>
            <a href="#" className="nav-link center-link">
              <img src={Logo} alt="logo"/>
            </a>
          </li>
          <li className="nav-item">
            <a href="#what-we-do" className="nav-link">
              <span className="nav-text">what we do</span>
            </a>
          </li>
          <li className="nav-item">
            <Link
              to="/python-audit"
              className="nav-link"
              style={{
                background: "transparent",
                border: "none",
                textDecoration: "none",
                cursor: "pointer"
              }}
            >
              <span className="nav-text">python-audit</span>
            </Link>
          </li>
          <li className={`nav-item logo-item ${isMenuOpen ? 'hidden' : ''} `}>
            <a href="#" className="nav-link center-link">
              <img src={Logo} alt="logo"/>
            </a>
          </li>
          <li className="nav-item">
            <Link
              to="#"
              className="nav-link"
              style={{
                background: "transparent",
                border: "none",
                textDecoration: "none",
                cursor: "pointer"
              }}
            >
              <span className="nav-text">design & branding</span>
            </Link>
          </li>
          <li className="nav-item">
            <a href="#contact" className="nav-link">
              <span className="nav-text">contact</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default HeaderSection;